(function () {
  const MANAGER_KEY = 'NouvacCloseAnnouncementBarManager';
  const ROOT_SELECTOR = '[data-close-announcement-bar-root]';
  const BUTTON_SELECTOR = '[data-close-announcement-bar-button]';
  const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;

  if (window[MANAGER_KEY]) {
    window[MANAGER_KEY].init(document);
    return;
  }

  const controllers = new Map();

  const getMatches = (scope, selector) => {
    if (!scope) return [];
    const matches = scope.matches?.(selector) ? [scope] : [];
    return matches.concat(Array.from(scope.querySelectorAll?.(selector) || []));
  };

  const ensureCopyCode = () => {
    if (typeof window.copyCode === 'function') return;
    window.copyCode = (event) => {
      const button = event.currentTarget;
      window.navigator.clipboard.writeText(button.dataset.code.trim());
      button.classList.add('success');
      setTimeout(() => button.classList.remove('success'), 2000);
    };
  };

  const isEditor = () => Boolean(window.Shopify?.designMode);

  const isActiveRoot = (root) => {
    const sectionRoot = root.closest('.close-announcement-bar-section');
    if (!sectionRoot || !root.isConnected) return false;
    if (sectionRoot.hidden || sectionRoot.getAttribute('aria-hidden') === 'true') return false;
    return !root.hidden && root.getAttribute('aria-hidden') !== 'true';
  };

  const isDismissed = (storageKey) => {
    if (!storageKey || isEditor()) return false;
    try {
      const storedValue = window.localStorage.getItem(storageKey);
      if (storedValue === null) return false;
      const expiresAt = Number(storedValue);
      if (Number.isFinite(expiresAt) && Date.now() < expiresAt) return true;
      window.localStorage.removeItem(storageKey);
      return false;
    } catch (error) {
      return false;
    }
  };

  const persistDismissed = (storageKey) => {
    if (!storageKey || isEditor()) return;
    try {
      window.localStorage.setItem(storageKey, String(Date.now() + DISMISS_DURATION_MS));
    } catch (error) {
      // Storage can be unavailable in privacy modes; dismissal still applies to this page.
    }
  };

  const initRoot = (root) => {
    if (controllers.has(root) || !isActiveRoot(root)) return;

    const button = root.querySelector(BUTTON_SELECTOR);
    if (!button) return;

    const storageKey = root.dataset.closeAnnouncementStorageKey || '';
    if (isDismissed(storageKey)) {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
    }

    const close = () => {
      window.NouvacAnnouncementCountdownManager?.destroy(root);
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      persistDismissed(storageKey);
    };

    button.addEventListener('click', close);
    controllers.set(root, {
      destroy() {
        button.removeEventListener('click', close);
        controllers.delete(root);
      }
    });
  };

  const init = (scope = document) => {
    getMatches(scope, ROOT_SELECTOR).forEach(initRoot);
  };

  const destroy = (scope) => {
    Array.from(controllers.entries()).forEach(([root, controller]) => {
      if (scope === root || scope?.contains?.(root)) {
        controller.destroy();
      }
    });
  };

  const manager = Object.freeze({ init, destroy });
  window[MANAGER_KEY] = manager;
  ensureCopyCode();

  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
  }

  init(document);
})();
